"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const b_1 = __importDefault(require("b_"));
const react_redux_1 = require("react-redux");
const notifications_styles_1 = __importDefault(require("./notifications.styles"));
const b = b_1.default.with('notifications');
const NotificationComponent = () => {
    const notification = (0, react_redux_1.useSelector)((state) => state.notifications);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: notifications_styles_1.default, className: b('') }, { children: notification && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('wrapper') }, { children: [(0, jsx_runtime_1.jsx)("div", { className: b('message-icon') }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('message-text') }, { children: notification.message }))] }))) })));
};
exports.default = NotificationComponent;
